import { BehaviorSubject } from "rxjs";
import JwtDecode from "jwt-decode";
import axios from "axios";

export default class API {
	static LoggedInEmail = new BehaviorSubject();
	static token = null;
	static idtoken = null;
	static PartnerType = null;
  static PartnerName = null;
	// This will be an axios client with a valid token attached for making authenticated calls
	static axiosauth;

	static SetToken(token, idtoken) {
		this.token = token;
    this.idtoken = idtoken;
		if (token) {
			this.axiosauth = axios.create({
				baseURL: EnvironmentConstants.API_PATH,
				headers: { Authorization: "Bearer " + this.idtoken
        },
			});

		} else {
			this.axiosauth = null;
		}
	}


  static SetPartnerType(partner_type) {
    this.PartnerType = partner_type;
  }

  static GetPartnerType() {
    return this.PartnerType;
  }

  static SetPartnerName(partner_name) {
    this.PartnerName = partner_name;
  }

  static GetPartnerName() {
    return this.PartnerName;
  }


  static SetPartnerEmail(partner_email) {
    this.PartnerEmail = partner_email;
  }

  static GetPartnerEmail() {
    return this.PartnerEmail;
  }

  static async liftAuthHeartbeat(){
	  const response = await this.axiosauth.get(EnvironmentConstants.API_PATH + "/heartbeat");
    return response
  }

	static async Login(email, password, rememberme) {

    const response = await axios.post(EnvironmentConstants.API_PATH + "/login", { username: email, password: password });

    console.log(response)
    console.log(response.data.body)
    if (response.data.body && response.data.body.AuthenticationResult.AccessToken) {
      this.SetToken(response.data.body.AuthenticationResult.AccessToken,
        response.data.body.AuthenticationResult.IdToken);


    	sessionStorage.setItem("levelfi-token", response.data.body.AuthenticationResult.AccessToken);
      sessionStorage.setItem("levelfi-idtoken", response.data.body.AuthenticationResult.IdToken);
      this.LoggedInEmail.next(email);


      this.SetPartnerEmail(email);
      /// Set the partner name
      /// Decode the id token
      let id_token = JwtDecode(this.idtoken)
      try{
        this.SetPartnerName(id_token.name);
      } catch (error){
        this.SetPartnerName("HardCoded");
      }

      /// Set the Partner Type
      // const decoded = JwtDecode(response.data.body.AuthenticationResult.AccessToken);
      let decoded = JwtDecode(this.token)
      if (decoded['cognito:groups']) {
        let partner_type_name = '';

        console.log(decoded['cognito:groups']);
        for(var i =0 ; i < decoded['cognito:groups'].length; i++){
          let x =  decoded['cognito:groups'][i];
          if (x.toLowerCase().indexOf("complete") >= 0){
            partner_type_name = 'complete_submit';

          }else if(x.toLowerCase().indexOf('partial') >= 0){
            partner_type_name = 'partial_submit';

          }else{
            partner_type_name = 'manual_submit';
          }
        };
        // console.log(partner_type_name)
        this.SetPartnerType(partner_type_name);
      } else {
        this.SetPartnerType(partner_type_name);
      };

      try {
        await API.liftAuthHeartbeat()
      } /// Force it to try twice if the first one fails
      catch (err) {
        await API.liftAuthHeartbeat()
      }



		// const response = await axios.post(EnvironmentConstants.API_PATH + "/login", { username: email, password: password, organization: EnvironmentConstants.USER_ORGANIZATION_ID });
		// console.log(response)
		// if (response.data && response.data.token && response.data.success) {
    //   this.SetToken(response.data.token);
    //
		// 	this.LoggedInEmail.next(email);
		// 	if (rememberme) {
		// 		localStorage.setItem("levelfi-token", response.data.token);
		// 	} else {
		// 		sessionStorage.setItem("levelfi-token", response.data.token);
		// 	}
    //

    //
    //   /// Get the User name
    //   if (decoded.name){
    //     this.SetPartnerName(decoded.name)
    //   }else {
    //     this.SetPartnerName("");
    //   }
    //
    //   /// Get the User email
    //   if (decoded.email){
    //     this.SetPartnerEmail(decoded.email)
    //   }else {
    //     this.SetPartnerEmail("");
    //   }

      //// Ping the middle ware server so it get a token
      // try {
      //   await API.liftAuthHeartbeat()
      // } /// Force it to try twice if the first one fails
      // catch (err) {
      //   await API.liftAuthHeartbeat()
      // }

    } else {
			throw new Error("Login failed");
		}
	}

	static async Forgot(email) {
		await axios.post(EnvironmentConstants.API_PATH + "/auth/reset", { email, organization: EnvironmentConstants.USER_ORGANIZATION_ID });
	}
	static async Reset(code, password) {
		await axios.post(EnvironmentConstants.API_PATH + "/auth/password_change", { code, password });
	}

	static Logout() {
		this.SetToken(null);
    this.SetPartnerType(null);
		localStorage.removeItem("levelfi-token");
		sessionStorage.removeItem("levelfi-token");
	}

	static LoadToken() {
		try {
			let token = sessionStorage.getItem("levelfi-token");
      let idtoken = sessionStorage.getItem("levelfi-idtoken");
			if (!token) {
				token = localStorage.getItem("levelfi-token");
			}
			if (token) {
				const decoded = JwtDecode(token);
				const current_time = Date.now().valueOf() / 1000;
				// console.log((decoded.exp - current_time) / 60 / 60);
				if (decoded.exp < current_time) {
					throw new Error("Token is expired");
				}

        // Make sure it has the required properties
        if (decoded.username) {
        	this.SetToken(token, idtoken);
        	this.LoggedInEmail.next(decoded.username);
          this.SetPartnerEmail(decoded.username);
        } else {
        	throw new Error("Invalid token contents");
        }

        /// Set the Partner Type
        if (decoded['cognito:groups']) {
          let partner_type_name = '';
          for(var i = 0; i < decoded['cognito:groups'].length; i++){
            let x =  decoded['cognito:groups'][i];
            if (x.toLowerCase().indexOf("complete") >= 0){
              partner_type_name = 'complete_submit';
            }else if(x.toLowerCase().indexOf('partial') >= 0){
              partner_type_name = 'partial_submit';
            }else{
              partner_type_name = 'manual_submit';
            }
          };
          // console.log(partner_type_name)
          this.SetPartnerType(partner_type_name);
        } else {
          this.SetPartnerType(partner_type_name);
        };

				// // Make sure it has the required properties
				// if (decoded.email) {
				// 	this.SetToken(token);
				// 	this.LoggedInEmail.next(decoded.email);
				// } else {
				// 	throw new Error("Invalid token contents");
				// }
        //
        // /// Set the Partner Type
        // if (decoded.partner_type) {
        //   this.SetPartnerType(decoded.partner_type);
        // } else {
        //   this.SetPartnerType("manual_submit");
        // }
        //
        // /// Get the User name
        // if (decoded.name){
        //   this.SetPartnerName(decoded.name)
        // }else {
        //   this.SetPartnerName("");
        // }
        //
        // /// Get the User email
        // if (decoded.email){
        //   this.SetPartnerEmail(decoded.email)
        // }else {
        //   this.SetPartnerEmail("");
        // }


			} /// End of if token

      if (idtoken){
        let id_token = JwtDecode(idtoken)
        try{
          this.SetPartnerName(id_token.name);
        } catch (error){
          this.SetPartnerName("HardCoded");
        }

      } /// End if ID token
		} catch (err) {
			console.error("Couldn't load stored token");
			console.error(err);
		}
	}

	static async QueryModel(payload) {
		return await this.axiosauth.post(EnvironmentConstants.API_PATH + "/scoreapi", payload);
	}

	static async QueryUsage(startdate, enddate) {
		let datefilter = "";
		if (startdate) {
			datefilter += "&start_date=" + startdate;
		}
		if (enddate) {
			datefilter += "&end_date=" + enddate;
		}
		return await this.axiosauth.get(EnvironmentConstants.API_PATH + "/passthrough/reports/types/default/system/api_usage?filter_http_method=POST&filter_api_route_name_pk=1401&user_aware=true" + datefilter);
	}

	static async GetClientVersion() {
		try {
			const response = await axios.get("/static/gitversion.txt");
			return response.data;
		} catch (err) {
			return "dev";
		}
	}

  static async createUseageRecord(usage_payload) {
    await this.axiosauth.post(EnvironmentConstants.API_PATH + "/usage", usage_payload);
  }

  static async crmPassthroughCongito(payload) {
    return await this.axiosauth.post(EnvironmentConstants.API_PATH + "/passthroughcrm", payload);
  }


  static async crmPassthroguh(lead_payload, levelfi_payload) {
	  /// CRM connect will check that we are able to submit data and create a lead entity
	  const response =  await this.axiosauth.post(EnvironmentConstants.API_PATH + "/crmconnect");
    /// Save yhr Lead ID to use in future requests
	  const leadId = response.data.ids.leadId;

    try{
	    if (response.data.success && leadId) {
        const response = await this.axiosauth.patch(EnvironmentConstants.API_PATH + '/ola/passthrough/leads(' + leadId + ')/', lead_payload);
      }

      let levelfi_location = {};
	    /// If we were able to create and push data to a lead, create levelFi
      if (response.status == 204 | response.status == 200) {
        const response = await this.axiosauth.post(EnvironmentConstants.API_PATH + "/ola/passthrough/new_levelfis()/", levelfi_payload);
        /// Save the levelfi guid from the response header into an object
        levelfi_location = {"@odata.id": response.headers['odata-entityid']};
      }else {
        throw new Error("Was not able to create LevelFi records");
      }

      /// Connect new LeavelFi Entity to Lead
      if(levelfi_location){
        const response_levelfipatch = await this.axiosauth.put(EnvironmentConstants.API_PATH + '/ola/passthrough/leads(' + leadId + ')/new_lead_new_levelfi/$ref', levelfi_location);
      }else{
        throw new Error("Was not able to attach LevelFi records");
      }


      return("Success")
    }catch(err){
      throw new Error("Was not able to create records")
    }


    /// Create a levelfi

  }

  static async getRecommendation(payload) {
    return await this.axiosauth.post(EnvironmentConstants.API_PATH + "/recommendation", payload);
  }

	static DownloadFile(filename, data) {
		const url = window.URL.createObjectURL(new Blob([data]));
		const link = document.createElement("a");
		link.href = url;
		link.setAttribute("download", filename);
		document.body.appendChild(link);
		link.click();
	}






} /// End export default class API

API.LoadToken();





// WEBPACK FOOTER //
// ./src/services/api.js